import { useState, type FormEvent } from 'react';
import { Button } from '@shared/ui/Button';
import { Modal } from '@shared/ui/Modal';
import {
  Form,
  Row,
  FormGroup,
  Label,
  Input,
  Select,
  ModalFormFooter,
} from './styled';

interface CreateTaxModalProps {
  open: boolean;
  onClose: () => void;
  onCreateTax: (data: {
    taxPeriod: string;
    taxDueDate: string;
    taxType: string;
    taxTitle: string;
    taxAmount: number;
    taxReserved?: number;
  }) => Promise<void>;
  isCreating: boolean;
}

export function CreateTaxModal({
  open,
  onClose,
  onCreateTax,
  isCreating,
}: CreateTaxModalProps) {
  const [taxPeriod, setTaxPeriod] = useState('2026-10');
  const [taxDueDate, setTaxDueDate] = useState('2026-10-28');
  const [taxType, setTaxType] = useState('vat_1_3');
  const [taxTitle, setTaxTitle] = useState('1/3 НДС за III кв. 2026');
  const [taxAmount, setTaxAmount] = useState('');
  const [taxReserved, setTaxReserved] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const amt = Number(taxAmount);
    if (!amt || amt <= 0) return;

    await onCreateTax({
      taxPeriod,
      taxDueDate,
      taxType,
      taxTitle,
      taxAmount: amt,
      taxReserved: taxReserved ? Number(taxReserved) : undefined,
    });
    setTaxAmount('');
    setTaxReserved('');
  };

  return (
    <Modal
      open={open}
      title="Новое налоговое обязательство ЕНС"
      onClose={onClose}
    >
      <Form onSubmit={handleSubmit}>
        <Row>
          <FormGroup>
            <Label>Период</Label>
            <Input
              placeholder="2026-10"
              value={taxPeriod}
              onChange={(e) => setTaxPeriod(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Срок уплаты (28 число)</Label>
            <Input
              type="date"
              value={taxDueDate}
              onChange={(e) => setTaxDueDate(e.target.value)}
              required
            />
          </FormGroup>
        </Row>

        <FormGroup>
          <Label>Вид налога</Label>
          <Select value={taxType} onChange={(e) => setTaxType(e.target.value)}>
            <option value="vat_1_3">1/3 НДС квартала</option>
            <option value="ndfl">НДФЛ с выплат работникам</option>
            <option value="insurance_contrib">Страховые взносы</option>
            <option value="profit_tax">Налог на прибыль</option>
            <option value="property_tax">Налог на имущество</option>
            <option value="ens_replenishment">Пополнение сальдо ЕНС</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Наименование обязательства</Label>
          <Input
            value={taxTitle}
            onChange={(e) => setTaxTitle(e.target.value)}
            required
          />
        </FormGroup>

        <Row>
          <FormGroup>
            <Label>Сумма начисления, ₽ *</Label>
            <Input
              type="number"
              placeholder="1500000"
              value={taxAmount}
              onChange={(e) => setTaxAmount(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Зарезервировано, ₽</Label>
            <Input
              type="number"
              placeholder="1000000"
              value={taxReserved}
              onChange={(e) => setTaxReserved(e.target.value)}
            />
          </FormGroup>
        </Row>

        <ModalFormFooter>
          <Button $variant="secondary" type="button" onClick={onClose}>
            Отмена
          </Button>
          <Button $variant="primary" type="submit" disabled={isCreating}>
            {isCreating ? 'Сохранение…' : 'Добавить'}
          </Button>
        </ModalFormFooter>
      </Form>
    </Modal>
  );
}
